exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folyamat-sav[data-v-a9cec44e]{position:fixed}", ""]);

// exports
